const getOrigin = () => {
  if (typeof window === 'undefined') return '';
  return window.location.origin || '';
};

export const toAbsoluteUrl = (path) => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const origin = getOrigin();
  return origin ? `${origin}${normalized}` : normalized;
};

export const getAdminPortalLoginUrl = () => toAbsoluteUrl('/login');

export const getStaffPortalLoginUrl = () => toAbsoluteUrl('/staff/login');

export const getStudentPortalLoginUrl = () => toAbsoluteUrl('/student-portal/login');
